import { Box, Grid2 as Grid, Tab, Tabs } from "@mui/material";
import OwnerTab from "../permitPackageTabs/OwnerTab";
import ContractorTab from "../permitPackageTabs/ContractorTab";
import RecordingTab from "../permitPackageTabs/RecordingTab";
import PermitSettings from "../permitPackageTabs/PermitSettings";
import NotarizationTab from "../permitPackageTabs/NotarizationTab";
import CitySiteTab from "../permitPackageTabs/CitySiteTab";
import { useDispatch, useSelector } from "react-redux";
import React, { useCallback, useState } from "react";
import { useTour } from "@reactour/tour";
import { setRightValue } from "../../../store/actions/uiActions/myPermitsActions";

const PermitPackageRightContent = ({
  recordLoading,
  handleStartRecord,
  setDocNotaryTypeValue,
  docNotaryTypeValue,
  selectedPermitType,
}) => {
  const { rightValue, activeTab, selectedRow } = useSelector(
    (state) => state.myPermitsComponent
  );

  const { isOpen } = useTour();
  const dispatch = useDispatch();

  const [isFading, setIsFading] = useState(false);

  const handleRightChange = useCallback(
    (event, newValue) => {
      if (isOpen) return;

      setIsFading(true);
      setTimeout(() => {
        if (rightValue !== newValue) {
          dispatch(dispatch(setRightValue(newValue)));
          setIsFading(false);
        }
      }, 300);
    },
    [isOpen, rightValue, dispatch]
  );

  // Function to determine which component to render
  const getRightTabComponent = () => {
    if (activeTab === 1 && selectedRow?.assigned_package?.is_assigned) {
      switch (rightValue) {
        case 0:
          return <OwnerTab selectedPermitType={selectedPermitType} />;
        case 1:
          return <ContractorTab selectedPermitType={selectedPermitType} />;
        default:
          return <OwnerTab selectedPermitType={selectedPermitType} />;
      }
    } else {
      switch (rightValue) {
        case 0:
          return <OwnerTab selectedPermitType={selectedPermitType} />;
        case 1:
          return <ContractorTab selectedPermitType={selectedPermitType} />;
        case 2:
          return (
            <NotarizationTab
              setDocNotaryTypeValue={setDocNotaryTypeValue}
              docNotaryTypeValue={docNotaryTypeValue}
              selectedPermitType={selectedPermitType}
            />
          );
        case 3:
          return (
            <RecordingTab
              recordLoading={recordLoading}
              handleStartRecord={handleStartRecord}
              selectedPermitType={selectedPermitType}
            />
          );
        case 4:
          return <CitySiteTab selectedPermitType={selectedPermitType} />;
        case 5:
          return <PermitSettings selectedPermitType={selectedPermitType} />;
        default:
          return <OwnerTab selectedPermitType={selectedPermitType} />;
      }
    }
  };

  return (
    <Grid
      className="step16 step17 step18 step19 step20 step21"
      size={{ sm: 4 }}
      sx={{
        borderLeft: "4px solid #d3d3d3",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignSelf: "stretch",
      }}
    >
      <Box
        sx={{
          maxWidth: "100%",
          bgcolor: "background.paper",
          display: "flex",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Tabs
          value={rightValue}
          onChange={handleRightChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable auto tabs example"
          slotProps={{
            indicator: { style: { height: "3px", bottom: "10px" } },
          }}
        >
          <Tab label="Property Owner" disableRipple />
          <Tab label="Contractor" disableRipple />
          <Tab
            label="Notarization"
            disableRipple
            sx={{
              display:
                activeTab === 1 && selectedRow?.assigned_package?.is_assigned
                  ? "none"
                  : undefined,
            }}
          />
          <Tab
            label="Recording"
            disableRipple
            sx={{
              display:
                activeTab === 1 && selectedRow?.assigned_package?.is_assigned
                  ? "none"
                  : undefined,
            }}
          />
          <Tab
            label="City Permit"
            disableRipple
            sx={{
              display:
                activeTab === 1 && selectedRow?.assigned_package?.is_assigned
                  ? "none"
                  : undefined,
            }}
          />
          <Tab
            label="Settings"
            disableRipple
            sx={{
              display:
                activeTab === 1 && selectedRow?.assigned_package?.is_assigned
                  ? "none"
                  : undefined,
            }}
          />
        </Tabs>
      </Box>

      <Box
        sx={{
          width: "100%",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          overflow: "auto",
          minHeight: 0,
        }}
        className={
          isFading
            ? "fade-exit fade-exit-active"
            : "fade-enter fade-enter-active"
        }
      >
        {getRightTabComponent()}
      </Box>
    </Grid>
  );
};

export default React.memo(PermitPackageRightContent);
